<template>
  <div class="center-orbit">
    <div class="side-arrow left-arrow"></div>
    <img src="../../assets/img/center.png" alt="" />
    <div class="side-arrow right-arrow"></div>
  </div>
</template>

<style lang="less" scoped>
.center-orbit {
  position: relative;
  min-width: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.center-orbit img {
  position: relative;
  z-index: 2;
  width: 790px;
  max-width: 96%;
  max-height: 86%;
  object-fit: contain;
  filter: drop-shadow(0 0 22px rgba(34, 255, 229, 0.3));
}

.side-arrow {
  position: absolute;
  z-index: 1;
  width: 290px;
  height: 138px;
  background: linear-gradient(90deg, rgba(45, 255, 230, 0.06), rgba(45, 255, 230, 0.36), rgba(45, 255, 230, 0.06));
  clip-path: polygon(0 50%, 18% 0, 100% 0, 82% 50%, 100% 100%, 18% 100%);
  opacity: 0.72;
}

.left-arrow {
  left: 2%;
}

.right-arrow {
  right: 2%;
  transform: rotate(180deg);
}
</style>
